import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

// Shown to a banned client who tries to book, join the waitlist or sign in. Firm, final, dignified.
export const refusedDetail = (e) => {
  const d = e?.response?.data?.detail;
  return d && typeof d === "object" && d.code === "banned" ? d : null;
};

export const RefusedDialog = ({ refused, onClose }) => (
  <Dialog open={!!refused} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="rounded-2xl sm:max-w-md" data-testid="booking-refused-dialog">
      <DialogHeader>
        <DialogTitle className="font-heading text-xl" data-testid="booking-refused-title">{refused?.title || "We're unable to take your booking"}</DialogTitle>
        <DialogDescription className="text-sm text-foreground/80 leading-relaxed pt-2" data-testid="booking-refused-message">{refused?.message}</DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button className="rounded-lg w-full sm:w-auto" onClick={onClose} data-testid="booking-refused-close">Close</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
